import { useAtomValue } from 'jotai/utils';
import { addonsSettingsAtom } from 'src/shared/settings/addons';

/**
 * Whether the Remove Background addon is enabled for the current user.
 *
 * Mirrors `useImageEditAvailable` — a per-user addon that must be both added
 * AND enabled. The SaaS API rejects the call server-side when it isn't, so
 * every surface that offers background removal (asset detail Edit menu, the
 * AI Agent nudges) gates on this rather than letting the request fail.
 */
export function useRemoveBackgroundAvailable(): boolean {
  const addonsSettings = useAtomValue(addonsSettingsAtom);
  return Boolean(
    addonsSettings?.REMOVE_BACKGROUND?.added && addonsSettings?.REMOVE_BACKGROUND?.enabled,
  );
}

export default useRemoveBackgroundAvailable;
